<div *ngIf="loadingIndicator" class="loading-indicator">{{loadingMessage}}</div>
<iframe #iframe id="iframe" sandbox="allow-forms allow-modals allow-popups allow-same-origin allow-scripts allow-top-navigation allow-downloads">
    <p>Please use a browser that support iframes.</p>
</iframe>